export enum PreferenceKey {
  ACCESS_TOKEN = 'access_token',
  CAN_READ_PROFILE = 'crp',
  INSTANCE_ID = 'lativ_instance_id',
  REDIRECT_URL = 'redirect_url',
  LOGIN_TYPE = 'login_type',
  LOGIN_PHONE = 'login_phone',
  KEYWORDS = 'keywords',
  CART = 'local_cart',
  TOP_ANNOUNCEMENT = 'top_announcement',
  ANNOUNCEMENT = 'announcement',
  FBNONCE = 'fb_nonce',
  NOTIFICATION_IDS = 'notification_ids',
  CS_UNREAD_INFO = 'cs_unread_info',
  FAVORITE = 'favorite',
  PHONE = 'penum',
  ADDRESS = 'local_address',
  OUTFIT_READ = 'outfit_read',
  CS_LAST_READ_ID = 'cs_last_read_id',
  ORDER_SIDEBAR_TAB = 'order_sidebar_tab',
  PROFILE_PIC_URL = 'profile_pic_url',
  PAGE_KEY = 'page_key',
  LAST_SEND_CODE_TIME = 'last_send_code_time',
  LAST_RESULT_ORDER = 'lro',
  AD_TRACKING_TIME = 'ad_time',
  AD_TRACKING_ID = 'ad_tracking_id',
  GUIDE_STOCK_REMIND = 'guid_stock_remind',
  GUIDE_CATEGORY_NAVIGATION = 'guid_category_navigation',
  GUIDE_OUTFIT = 'guid_outfits',
  GUIDE_LIST_MODE = 'guid_list_mode',
  GUIDE_SALES_EVENT = 'guid_sales_event',
  GUIDE_DETAIL = 'guid_detail',
  GUIDE_CART_DIALOG = 'guid_cart_dialog',
  PENDING_CREDIT_CARD_CHECK_PAYMENT = 'pending_credit_card_check_payment',
}
